import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=3bce59aa&scoped=true&"
import script from "../../../../js/views/user/components/ChangePasswordForm.js?vue&type=script&lang=js&"
export * from "../../../../js/views/user/components/ChangePasswordForm.js?vue&type=script&lang=js&"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=3bce59aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bce59aa",
  null
  
)

export default component.exports